import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useBreakpoint = () => {
  const { breakpoints } = useTheme();

  const isExtraSmall = useMediaQuery(() => breakpoints.down('xs'));
  const isMobile = useMediaQuery(() => breakpoints.down('sm'));
  const isTablet = useMediaQuery(() => breakpoints.between('sm', 'lg'));
  const isBelowTablet = useMediaQuery(() => breakpoints.down('md'));
  const isBelowLg = useMediaQuery(() => breakpoints.down('lg'));
  const isDesktop = useMediaQuery(() => breakpoints.up('lg'));
  const isExtraLarge = useMediaQuery(() => breakpoints.up('xl'));

  return {
    isExtraSmall,
    isMobile,
    isTablet,
    isBelowTablet,
    isBelowLg,
    isDesktop,
    isExtraLarge,
  };
};

export default useBreakpoint;
